import { Factory, Landmark,Package, Scroll, Utensils } from "lucide-react";

/**
 * Case-study data, the non-copy half of each card. This table owns the set and
 * order; the page keys each card's copy by its `vp` slug in
 * `cases.items.<vp>` (`locales/{it,en}/companies-home.json`) and resolves the
 * value-proposition slug through `VALUE_PROPS` (that table lives in
 * `3-features`, which this layer may not import).
 */
export const CASES = [
  {
    icon: Factory,
    image: "/images/cases/company-1-1376.webp",
    imageSrcSet: "/images/cases/company-1-480.webp 480w, /images/cases/company-1-900.webp 900w, /images/cases/company-1-1376.webp 1376w",
    vp: "riduzione-prevedibile",
  },
  {
    icon: Package,
    image: "/images/cases/company-2-1264.webp",
    imageSrcSet: "/images/cases/company-2-480.webp 480w, /images/cases/company-2-900.webp 900w, /images/cases/company-2-1264.webp 1264w",
    vp: "conformita",
  },
  {
    icon: Scroll,
    image: "/images/cases/company-3-896.webp",
    imageSrcSet: "/images/cases/company-3-480.webp 480w, /images/cases/company-3-896.webp 896w",
    vp: "ebitda",
    mirror: true, // subject sits left, behind the copy panel, flip it into view
  },
  {
    icon: Utensils,
    image: "/images/cases/company-4-1376.webp",
    imageSrcSet: "/images/cases/company-4-480.webp 480w, /images/cases/company-4-900.webp 900w, /images/cases/company-4-1376.webp 1376w",
    vp: "copertura-naturale",
  },
  {
    icon: Landmark,
    image: "/images/cases/company-5-1400.webp",
    imageSrcSet: "/images/cases/company-5-480.webp 480w, /images/cases/company-5-900.webp 900w, /images/cases/company-5-1400.webp 1400w",
    vp: "impatto",
  },
] as const;
